<template>
  <div class="write-off-table">
    <form class="write-off-table__head">
      <div class="write-off-table__cell">Дата</div>
      <div class="write-off-table__cell">Автор</div>
      <div class="write-off-table__cell">Итоговая стоимость</div>
    </form>
    <div class="write-off-table__body-mobile">
      <button
        class="write-off-table__body-mobile__button-row"
        type="button"
        v-for="({
          id,
          date,
          author,
          amount,
        }) in writeOffList"
        v-bind:key="id"
        v-on:click="onEditWriteOff(id)">
        <dl class="write-off-table__body-mobile__row">
          <dt>Дата</dt>
          <dd>{{ date }}</dd>
          <dt>Автор</dt>
          <dd>{{ author }}</dd>
          <dt>Итоговая стоимость</dt>
          <dd>{{ getProcessedAmount(amount) }}</dd>
        </dl>
      </button>
    </div>
    <div
      v-if="!this.isWriteOffListEmpty && !this.isAwaitRequest"
      class="write-off-table__body"
    >
      <button
        class="write-off-table__row"
        type="button"
        v-for="({
          id,
          date,
          author,
          amount,
        }) in writeOffList"
        v-on:click="onEditWriteOff(id)"
        v-bind:key="id">
        <div
          data-label="Дата"
          class="write-off-table__cell">{{ date }}</div>
        <div
          data-label="Автор"
          class="write-off-table__cell">{{ author }}</div>
        <div
          data-label="Итоговая стоимость"
          class="write-off-table__cell">{{ getProcessedAmount(amount) }}</div>
        <div
          data-label="Редактировать"
          class="write-off-table__cell"
        >
          <button
            class="write-off-table__icon-edit"
            type="button"
            v-on:click.prevent.stop="onEditWriteOff(id)" />
        </div>
        <div
          data-label="Удалить"
          class="write-off-table__cell">
          <button
            class="write-off-table__icon-delete"
            type="button"
            v-on:click.prevent.stop="onDeleteWriteOff(id)" />
        </div>
      </button>
    </div>
    <div
      v-else-if="!isAwaitRequest"
      class="write-off-table__message"
    >
      Ничего не найдено
    </div>
  </div>
</template>
<script>

/**
 * @description Таблица списаний.
 * @type {any}
 */
export default {
  computed: {
    /**
     * @description Является ли список списаний пустым.
     * @returns {boolean}
     */
    isWriteOffListEmpty() {
      return !Object.keys(this.writeOffList).length;
    },
  },
  methods: {
    /**
     * @description Обработать удаление списания.
     * @param {number} id Идентификатор списания.
     * @returns {void}
     */
    onDeleteWriteOff(id) {
      this.$emit('delete-write-off', id);
    },
    /**
     * @description Обработать редактирование списания.
     * @param {number} id Идентификатор списания.
     * @returns {void}
     */
    onEditWriteOff(id) {
      this.$emit('edit-write-off', id);
    },
    /**
     * @description Обработать вывод итоговой стоимости.
     * @param {string} value Итоговая стоимость.
     * @returns {string}
     */
    getProcessedAmount(value) {
      return value
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },
  },
  props: {
    /**
     * @description Список списаний.
     * @type {any[]}
     */
    writeOffList: { type: Array, required: true },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: { type: Boolean, required: true },
  },
};
</script>
<style lang="scss">

.write-off-table {
  margin: 25px 0 0 0;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__button-row {
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
    }
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      align-items: center;
      row-gap: 5px;
      padding: 5px;
      & > dt {
        justify-self: flex-start;
      }
      & > dd {
        text-align: right;
      }
    }
  }
  &__head,
  &__row {
    width: 100%;
    display: grid;
    grid-template-columns:
    minmax(100px, 200px)
    repeat(2, 1fr)
    repeat(2, 43px);
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    text-align: center;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    padding: 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__cell {
    padding: 12px 8px;
    transition: color var(--animate-duration);
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .write-off-table {
    &__head,
    &__row {
      grid-template-columns: repeat(3, 1fr) repeat(2, 43px);
      font-size: 12px;
      line-height: 17px;
    }
  }
}
@media screen and (max-width: 1100px) {
  .write-off-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
    }
    &__cell::before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 480px) {
  .write-off-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}

.items-table {
  margin-top: 10px;
}
.items-header,
.items-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
}
.items-header {
  font-weight: bold;
}
</style>
